import { Props } from '@components/BlockMapper';
import { Button } from '@components/Button/';
import DevelopmentCard from '@components/Card/DevelopmentCard';
import Block from '@components/Layout/Block';
import { VerticalLineSeparator } from '@components/MiscComponents/VerticalLineSeparator';
import { contentAspectRatios } from '@components/NeighborhoodCardGrid';
import {
  ButtonPadding,
  Headline,
  NeighborhoodWrapper,
} from '@components/NeighborhoodCardGrid/styles';
import { ListingSortKeys, SortDir } from '@engelvoelkersamericas/api';
import { useShop } from '@util/customHooks/useShop';
import { mapDevelopmentResults } from '@util/developmentMapping';
import { apiClient } from 'api-client';
import { useTranslations } from 'next-intl';
import { useParams, usePathname } from 'next/navigation';
import { FC, useEffect, useState } from 'react';

// Forked from @components/NeighborhoodCardGrid
const FeaturedDevelopments: FC<Props> = (props) => {
  const t = useTranslations();
  // If the shop is present in the URL, then we need to modify the URL to also have the shopname.
  const params = useParams();
  const pathname = usePathname();
  const hasShopInURL = pathname.includes('/shops/');
  const shopName = params.shopname as string;
  const developmentListingsUrl = hasShopInURL
    ? `/shops/${shopName}/explore/development-services/listings`
    : '/explore/development-services/listings';

  const { headline, developmentIds } = props;
  const { shop } = useShop();

  // get development data from the developmentIds in useEffect
  const [developments, setDevelopments] = useState<any[]>([]);
  const getDevelopments = async (ids: string[] | undefined) => {
    if (ids) {
      const results = await apiClient.getListingsByIds({
        listingsByIdBody: {
          listingAndMlsIds: ids.map((id) => ({
            listingId: id,
            listOfficeMlsId: null,
          })),
        },
        size: 5,
        page: 1,
        sortKey: ListingSortKeys.EvaId,
        sortDir: SortDir.Asc,
      });

      const mapped = await mapDevelopmentResults(results.data.listings, shop, shopName);
      setDevelopments(mapped);
    }
  };
  useEffect(() => {
    if (developmentIds) {
      getDevelopments(developmentIds);
    } else {
      getDevelopments([]);
    }
  }, [developmentIds]);

  return (
    <Block>
      <Headline>{headline ? headline : t('New Communities')}</Headline>
      <VerticalLineSeparator />
      {developments && developments.length > 0 && (
        <NeighborhoodWrapper $amount={developments.length}>
          {developments.map((development: any, i: number) => {
            return (
              <div key={i}>
                <DevelopmentCard
                  img={development.img}
                  title={development.title}
                  url={development.url ? `${development.url}` : null}
                  imageAspectRatio={contentAspectRatios[developments.length][i]}
                />
              </div>
            );
          })}
        </NeighborhoodWrapper>
      )}
      {developments && developments.length > 0 && (
        <ButtonPadding>
          <Button
            variant="secondary"
            label={t('View All Developments')}
            url={developmentListingsUrl}
            arrow={false}
          />
        </ButtonPadding>
      )}
    </Block>
  );
};

export default FeaturedDevelopments;
